module.exports = __webpack_public_path__ + "img/0783877.svg";